import React from "react";

const PageTitle = ({ title }) => {
  return <div className="text-xl uppercase">{title}</div>;
};

export default PageTitle;
